import { CSSObject } from '@chakra-ui/react';
import { EWithdrawalStatus } from '@/lib/DBModels';
import { CustomButtonProps } from '@/components/Button/Button';

export const buttonWithdrawalCardCancelProps: CustomButtonProps = {
  variant: 'secondary',
};

export const buttonWithdrawalProps: CustomButtonProps = {
  variant: 'secondary',
};

export const Heading: CSSObject = {
  color: 'white',
  fontSize: 'sm',
};

export const DividerWithdrawal: CSSObject = {
  borderColor: 'alpha.300',
  borderStyle: 'dashed',
};

export const TextDescription: CSSObject = {
  color: 'white',
};

/**
 * Form Inputs
 */
export const InputWrapperWithdrawal: CSSObject = {
  '.chakra-form__label': {
    color: 'white',
  },
  '.chakra-form__helper-text': {
    color: 'white',
    fontWeight: 'medium',
    fontSize: 'sm',
  },
  '.chakra-input': {
    borderRadius: 'base',
  },
};

export const InputWithdrawal: CSSObject = {
  bg: 'zeta.100',
  border: '1px solid',
  borderRadius: 'sm',
  fontSize: 'sm',
  height: '38px',

  _placeholder: {
    color: 'gray.700',
  },
  _focus: {
    bg: 'zeta.100',
  },
};

export const buttonAddAccountProps: CustomButtonProps = {
  variant: 'secondary',
};

export const ButtonWithdrawal: CSSObject = {
  bgGradient: 'linear-gradient(180deg, #FCD236 0%, #E79004 100%)',
  color: 'alpha.700',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.3)',
  borderWidth: '2px',
  borderColor: '#CD8715',
  textTransform: 'uppercase',
  fontSize: '12px',
  fontWeight: 'bold',
  '&:hover, &:focus': {
    bgGradient: 'linear-gradient(180deg, #FACD33 0%, #EC9E0F 100%)',
    color: 'alpha.700',
  },

  _active: {
    bg: 'beta.600',
    color: 'alpha.700',
    boxShadow:
      '0px 0px 0px 3px rgba(255, 255, 255, 0.25) inset, 0px 3px 4px 0px rgba(0, 0, 0, 0.25)',
  },
};

export const ButtonIncrease: CSSObject = {
  bgGradient: 'linear-gradient(180deg, #FACD33 0%, #EC9E0F 100%)',
  color: 'alpha.700',
  textShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.30)',
  boxShadow: '0px 0px 0px 3px rgba(255, 255, 255, 0.25) inset',
  lineHeight: '12px',
  textTransform: 'uppercase',
  '&:hover, &:focus': {
    bgGradient: 'linear-gradient(180deg, #FACD33 0%, #EC9E0F 100%)',
    color: 'alpha.700',
    boxShadow:
      '0px 0px 0px 3px rgba(255, 255, 255, 0.25) inset, 0px 3px 4px 0px rgba(0, 0, 0, 0.25)',
  },

  _active: {
    bg: 'beta.600',
    color: 'alpha.700',
    boxShadow:
      '0px 0px 0px 3px rgba(255, 255, 255, 0.25) inset, 0px 3px 4px 0px rgba(0, 0, 0, 0.25)',
  },
};

export const AmountInputWrapperWithdrawal: CSSObject = {
  mt: '2',
};

/**
 * Bank Account Radios
 */
export const BankRadioWrapper: CSSObject = {
  w: 'full',
  alignItems: 'center',
  justifyContent: 'space-between',
  py: '5',
  px: '2',
  borderBottom: '1px dashed',
  borderColor: 'alpha.300',
};

export const BankRadio: CSSObject = {
  alignItems: 'start',
  border: 'none',
  boxShadow: 'inset 0px 2px 4px rgba(49, 57, 77, 0.82)',

  '&[data-checked]': {
    boxShadow: 'none',
    _hover: {
      bg: 'gray.400',
    },
  },

  '&[data-checked]:before': {
    display: 'flex',
    alignSelf: 'center',
    width: '40%',
    height: '40%',
  },
};

export const BankCardContainer: CSSObject = {
  mt: '-3',
  bg: 'transparent',
  color: 'white',
};

export const FlexBankDetailsContainer: CSSObject = {
  fontSize: 'xs',
};

export const TextBankAccountDetail: CSSObject = {
  color: 'white',
  '.chakra-checkbox__control': {
    bg: 'white',
  },
  '.chakra-checkbox__control[data-checked]': {
    bg: 'black',
  },
};

/**
 * Withdrawal Requests Aside
 */
export const ListContainer: CSSObject = {
  bg: 'transparent',
  boxShadow: 'none',
  mt: '0',
  pt: '0',
  w: ['100%', null, '330px'],
};

export const ListContainerHeading: CSSObject = {
  display: 'none',
};

/**
 * Withdrawal Request Card
 */
export const WithdrawalWrapper: CSSObject = {
  bg: 'white',
  color: 'white',
  fontSize: 'sm',
  mt: ['4', null, '0'],
  boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.20)',
  borderRadius: 'base',
  border: 'none',
};

export const WithdrawalCardDetailHeading: CSSObject = {
  fontSize: 'sm',
  color: 'alpha.700',
  borderBottom: '1px dashed',
  borderColor: 'gray.300',
};

export const WithdrawalCardDetail: CSSObject = {
  borderBottom: '1px dashed',
  borderColor: 'gray.300',
  color: 'alpha.700',

  '.withdrawName': {
    fontSize: 'xs',
  },
};

export const WithdrawalCardDetailNumber: CSSObject = {
  borderBottom: '1px dashed',
  borderColor: 'gray.300',
  color: 'alpha.500',
  fontSize: 'xs',
};

export const WithdrawalCardDetailRequested: CSSObject = {
  fontWeight: '700',
  color: 'alpha.700',
  fontSize: 'xs',
  borderBottom: '1px dashed',
  borderColor: 'gray.300',
};

export const WithdrawalStatus = ({ status }: any): CSSObject => ({
  borderRadius: 'base',
  px: '2',
  color: 'white',
  textTransform: 'uppercase',
  fontSize: 'xs',
  bg: () => {
    switch (status) {
      case EWithdrawalStatus.Cancelled:
        return 'gray.500';
      case EWithdrawalStatus.Error:
        return 'red.500';
      case EWithdrawalStatus.Pending:
        return 'yellow.500';
      case EWithdrawalStatus.Processed:
        return 'gamma.400';
      case EWithdrawalStatus.Rejected:
        return 'red.500';
      default:
        return 'green.500';
    }
  },
});

export const Subheading: CSSObject = {
  color: 'white',
};
